<template>
  <div class="category">
    <div class="catagory_meaasge">
      <div class="line"></div>
      <div class="cataGory_title">类目管理</div>
      <div class="fuwenben">（拖动分类标签可改动顺序）</div>
    </div>

    <el-button class="addbtn" @click="showInput" type="primary" icon="el-icon-plus">添加分类</el-button>

    <ul
      class="tags"
      @dragstart="onDragStart"
      @dragover="onDragOver"
      @dragend="onDragEnd"
      ref="parentNode"
    >
      <li
        v-for="(item, index) in dynamicTags"
        :key="index"
        draggable="true"
        @click="li_click(index)"
      >
        <el-input
          v-show="item.active"
          @blur="handleInputConfirm(index)"
          v-model="item.name"
          ref="saveTagInput"
          size="small"
          maxlength="10"
        ></el-input>
        <i v-show="!item.active" ref="savaSpan">{{item.name}}</i>
        <i class="el-icon-error delIcon" @click.stop="iconClick(index)"></i>
      </li>
    </ul>

    <vdialog ref="vdialog" :title="title" :message="message" @isOk="sure_del"></vdialog>
  </div>
</template>

<script>
  import vdialog from "../components/dialog.vue";

  export default {
    components: {
      vdialog
    },
    data() {
      return {
        dynamicTags: [],
        title: "是否删除该类目",
        message: "请确保该类目下无上架中的商品",
        tag: null, // 要删除的下标
        draging: null, // 拖拽用到的
        target: null, // 拖拽用到的
        backDataList: [], // 拖拽用到的
        istrue: true, // 来判断是删除还是编辑
        orderFlagList: [] // 拖拽后的数组
      };
    },
    mounted() {
      //为了防止火狐浏览器拖拽的时候以新标签打开，此代码真实有效
      document.body.ondrop = function (event) {
        event.preventDefault();
        event.stopPropagation();
      };
    },
    created() {
      // 调用接口
      this.categoryList();
    },
    methods: {
      // 对话框确认返回的
      sure_del() {
        // 调用接口删除
        this.$axios
          .post(this.$url.categorydelete, {
            id: this.tag
          })
          .then(res => {
            console.log("我是要删除的", res);
            if (res.code === 0) {
              this.categoryList();
              this.$message.success("删除成功")
            }
          });
      },
      // 新增按钮点击
      showInput() {
        this.dynamicTags.push({
          name: "",
          active: true,
          id: "1"
        });
        this.$nextTick(() => {
          this.$refs.saveTagInput[this.$refs.saveTagInput.length - 1].focus();
        });
        this.istrue = true;
      },
      // 失去焦点
      handleInputConfirm(index) {
        this.dynamicTags[index].active = false;
        if (this.dynamicTags[index].name.trim()) {
          var name = this.dynamicTags[index].name;
          var isName = this.dynamicTags.findIndex(_ => {
            return _.name == name;
          });
          if (isName != index) {
            this.$message("该标签已存在");
            this.dynamicTags.splice(index, 1);
            return;
          } else {
            if (this.dynamicTags.length > 20) {
              this.$message.error("最多添加二十个类目");
              this.dynamicTags.splice(index, 1);
              return;
            } else {
              // 判断是新增还是编辑 调用接口
              if (this.istrue) {
                this.$axios
                  .post(this.$url.categoryadd, {
                    name: name
                  })
                  .then(res => {
                    console.log("我是新增类目", res);
                    this.$message.success('添加成功')
                    this.categoryList()
                  });
              } else {
                // 编辑接口
                var id = this.dynamicTags[index].id;
                this.$axios
                  .post(this.$url.categoryupdate, {
                    name: name,
                    id: id
                  })
                  .then(res => {
                    console.log("我是编辑类目", res);
                     this.$message.success('修改成功')
                    this.categoryList()
                  });
                this.dynamicTags = this.dynamicTags.map(_ => {
                  _.active = false;
                  return _;
                });
              }
            }
          }
        } else {
          this.dynamicTags.splice(index, 1);
        }
      },
      // li标签点击事件
      li_click(index) {
        this.dynamicTags = this.dynamicTags.map((_, i) => {
          _.active = false;
          if (index == i) _.active = true;
          return _;
        });
        this.$nextTick(() => {
          this.$refs.saveTagInput[index].focus();
        });
        this.istrue = false;
      },
      // 删除图标点击事件
      iconClick(index) {
        this.$refs.vdialog.centerDialogVisible = true;
        this.tag = this.dynamicTags[index].id;
      },
      // 获取类目列表
      categoryList() {
        this.$axios.post(this.$url.categoryList, {}).then(res => {
          console.log("我是商品类目", res);

          this.dynamicTags = res.data;
          this.dynamicTags.splice(20);
          this.dynamicTags = this.dynamicTags.map(item => {
            item["active"] = false;
            return item;
          });
        });
      },
      // 调用拖拽接口
      getDraggable() {
        console.log(this.orderFlagList);

        let list = this.orderFlagList.map((_, index) => {
          _.orderFlag = index
          return {id: _.id, orderFlag: _.orderFlag};
        });
        // 使用接口
        this.$axios
          .post(this.$url.modifyOrder, {
            list: list
          })
          .then(res => {
            console.log("我是拖拽后的", res);
            if (res.code == 0) {
              this.$message.success("更改成功!");
            }
          });
      },

      // 拖拽换位置
      onDragStart(event) {
        console.log("drag start");
        this.draging = event.target;
      },

      onDragOver(event) {
        console.log("drag move");
        this.target = event.target;
        let targetTop = event.target.getBoundingClientRect().top;
        let dragingTop = this.draging.getBoundingClientRect().top;
        if (this.target.nodeName === "LI" && this.target !== this.draging) {
          if (this.target) {
            if (this.target.animated) {
              return;
            }
          }

          if (this._index(this.draging) < this._index(this.target)) {
            this.target.parentNode.insertBefore(
              this.draging,
              this.target.nextSibling
            );
          } else {
            this.target.parentNode.insertBefore(this.draging, this.target);
          }
          this._anim(targetTop, this.target);
          this._anim(dragingTop, this.draging);
        }
      },
      _anim(startPos, dom) {
        let offset = startPos - dom.getBoundingClientRect().top;
        dom.style.transition = "none";
        dom.style.transform = `translateY(${offset}px)`;

        //触发重绘
        dom.offsetWidth;
        dom.style.transition = "transform .3s";
        dom.style.transform = ``;

        clearTimeout(dom.animated);

        dom.animated = setTimeout(() => {
          dom.style.transition = "";
          dom.style.transform = ``;
          dom.animated = false;
        }, 300);
      },
      onDragEnd(event) {
        console.log("drag end");
        let currentNodes = Array.from(this.$refs.parentNode.childNodes);
        // console.log(currentNodes);
        let arr = this.dynamicTags;
        let resArr = [];
        let data = currentNodes.map((i, index) => {
          // console.log(i.innerText);
          for (var j = 0; j < arr.length; j++) {
            if (i.innerText == arr[j].name) {
              resArr.push(arr[j]);
            }
          }
        });
        this.backDataList = resArr;

        // 将拖拽后的数组放到全局
        this.orderFlagList = resArr;
        // 调用拖拽接口
        this.getDraggable();
      },
      _index(el) {
        let domData = Array.from(this.$refs.parentNode.childNodes);
        // console.log("111", domData);
        return domData.findIndex(i => i.innerText == el.innerText);
      }
    }
  };
</script>

<style lang='less' scoped>
  .category {
    width: 100%;
    height: 100%;
    padding: 30px;
    background-color: #fff;
    box-sizing: border-box;
  }

  ::v-deep .delIcon {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 12px;
    height: 10px;
    color: #ccc;
  }

  .tags {
    margin-left: 10px;
    width: 1100px;
    display: flex;
    flex-wrap: wrap;

    li {
      position: relative;
      text-align: center;
      margin-right: 16px;
      width: 189px !important;
      height: 32px !important;
      background: rgba(246, 246, 246, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      color: #000;
      text-align: center;
      line-height: 32px;
      margin-bottom: 20px;
      cursor: pointer;
      border-radius: 5px;
    }
  }

  ::v-deep .el-input__inner {
    // width: 189px !important;
    // border: none;
    height: 32px !important;
    text-align: center;
    border-radius: 5px;
  }

  .addbtn {
    margin-left: 10px;
    margin-bottom: 25px;
  }

  .catagory_meaasge {
    display: flex;
    align-items: center;
    margin-bottom: 25px;
  }

  .line {
    width: 3px;
    height: 19px;
    background: rgba(102, 102, 102, 1);
    margin-right: 5px;
  }

  .cataGory_title {
    font-size: 18px;
    margin-right: 5px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }

  .fuwenben {
    font-size: 14px;
    font-weight: 400;
    color: rgba(245, 108, 108, 1);
  }
</style>
